import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  justify-content: center;

  @media (min-width: 768px) {
    background: linear-gradient(180deg, #7daff0 0%, #fefefe 100%);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 500px;
  }

  @media (max-width: 768px) {
    height: 600px;
  }
`;

export const ImageTitleContainer = styled.div`
  @media (max-width: 768px) {
    background-image: url("https://tripmoneycmsimgak.mmtcdn.com/img/splash_primary_bg_3x_94eb4395f7.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 200px 16px 0 16px;
  }
  width: 100%;
  padding: 16px 16px 0 16px;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
`;

export const Title = styled.div`
  width: 100%;
  height: auto;
  font-size: 32px;
  font-weight: 700;
  margin-top: 16px;
  color: ${theme.blackText};
  text-align: center;
`;

export const Description = styled.div`
  font-size: 18px;
  font-weight: 500;
  width: 100%;
  height: auto;
  margin-top: 12px;
  color: ${theme.blackText};
  text-align: center;
  line-height: 100%;
  padding: 0 16px;
`;

export const AdditionalInfo = styled.div`
  width: 100%;
  height: auto;
  font-size: 16px;
  margin-top: 18px;
  color: #4a4a4a;
  text-align: center;
  line-height: 100%;
  padding: 0 16px;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  width: 100%;
  gap: 16px;
`;

export const ModalButton = styled.button<{
  isSecondary: boolean;
  bgColors: string[];
}>`
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  flex: 1;
  transition: all 0.3s ease;

  ${({ isSecondary, bgColors }) =>
    isSecondary
      ? `
        background-color: ${bgColors[0] || "#FFFFFF"};
        color: #008CFF;
        border: 1px solid #008CFF;
      `
      : `
        background: ${
          bgColors.length > 1
            ? `linear-gradient(to right, ${bgColors.join(", ")})`
            : bgColors[0] || "#53B2FE"
        };
        color: #FFFFFF;
        border: none;
      `}

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 140, 255, 0.3);
  }
`;
